import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAvailableProducts } from "@/hooks/products";
export default function NoActiveContractBanner() {
    const { data: availableProducts, isLoading } = useAvailableProducts();
    // Don't show while loading or if there are active products
    if (isLoading || !availableProducts || availableProducts.products.length > 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-amber-100 border-b border-amber-300 px-6 py-3 w-full",
        children: /*#__PURE__*/ _jsxs("p", {
            className: "text-amber-800 text-sm text-center",
            children: [
                "No active product or contract. Please contact",
                " ",
                /*#__PURE__*/ _jsx("a", {
                    href: "mailto:support@qrypt.com",
                    className: "underline font-medium hover:text-amber-900",
                    children: "support@qrypt.com"
                })
            ]
        })
    });
}
